import * as React from 'react';
import { ListInput, BaseComponentClass, BasicCompoClassProps } from '../generic/ListInput';
import { Input, Dropdown } from 'semantic-ui-react';
import { ContactType } from 'src/services/graphql/Models';
import validator from 'validator';

interface ContactInfoInputProps {
    onChange: (e: Event, data: {name: string, value: string}) => any;
    name: string;
    initialValue: any;
}

const contactOptions = [
    {
        key: ContactType.email,
        text: 'E-Mail',
        value: ContactType.email,
        icon: 'mail'
    },
    {
        key: ContactType.sms,
        text: 'SMS',
        value: ContactType.sms,
        icon: 'text telephone'
    }
];

class ContactInfoInput extends BaseComponentClass {
    
    render() {
        let { contactType, contact } = this.state || { contactType: undefined, contact: undefined };

        return (
            <div>
                <Input
                    label={<Dropdown 
                        name="contactType"
                        defaultValue={contactType} 
                        options={contactOptions} 
                        onChange={this.changeHandler}
                    />}
                    className="sub-inputs"
                    labelPosition="left"
                    defaultValue={contact}
                    name="contact"
                    onChange={this.changeHandler}
                    disabled={
                        typeof contactType === undefined 
                        || ( 
                            contactType !== ContactType.email 
                            && contactType !== ContactType.sms
                        )
                    }
                    {...(
                        contactType === ContactType.email ?
                        {
                            placeholder: 'abc@example.com',
                            type: 'email'
                        }
                        : contactType === ContactType.sms ?
                        {
                            placeholder: '+64123456789',
                            type: 'text',
                        }
                        : {}
                    )}
                />
            </div>
        );
    }
}

export default class ContactInfoInputs extends React.Component<ContactInfoInputProps> {
    validate(_value: any): boolean | string {
        let value = _value && typeof _value.contact  === 'string' ? 
            _value.contact
            : '';
        switch (_value.contactType) {
            case ContactType.email:
                if (validator.isEmail(value)) {
                  return true;  
                } else {
                    return `Invalid Email address: ${value}`;
                }
            case ContactType.sms:
                if (/^\+?\d{10,15}$/.test(value)) {
                    return true;
                } else {
                    return `Invalid Contact number: ${value}`;
                }
            default:
                return 'Invalid Contact Type';
        }
    }
    
    handleValuesChange(values: any) {
        this.props.onChange({} as any, { name: this.props.name, value: values});
    }

    render() {
        return (
            <ListInput
                initialValues={this.props.initialValue}
                defaultValue={() => {
                    return  {
                        contactType: ContactType.email
                    };
                }}
                name={this.props.name}
                onValuesChange={this.handleValuesChange.bind(this)}
                validate={this.validate.bind(this)}
                Item={(props: BasicCompoClassProps) => <ContactInfoInput {...props}/>}
                StagingItem={(props: BasicCompoClassProps) => <ContactInfoInput {...props}/>}
                addButtonText="Add Contact"
            />
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/inputs/ContactInfoInput.tsx